import { useContext } from "react";
import { BrandingContext } from "./BrandingContext";

export function useBrandingContext() {
  const branding = useContext(BrandingContext);
  if (!branding) {
    throw new Error("useBranding must be used within a BrandingProvider");
  }
  return branding;
}
